import moment from 'moment-timezone';
import { createSelector } from 'reselect';
import { isEverbridgeFlowDesignerApp } from 'selectors/featureToggles';

const getClientSession = state => state?.session?.clientSession;

export const getWillRefresh = state => getClientSession(state)?.willRefresh;
export const getNextRefresh = state =>
  moment(getClientSession(state)?.nextRefresh);
export const getExpiresAt = state => moment(getClientSession(state)?.expiresAt);
export const getMaxSessionDuration = state =>
  getClientSession(state)?.maxSessionDuration;
export const isReportingPagesExcluded = state =>
  getClientSession(state)?.reportingPagesExcluded;
export const isSamlEnabled = state => getClientSession(state)?.isSamlEnabled;
export const isLoggedOut = state => getClientSession(state).isLoggedOut;
export const isUsingCAS = state => isEverbridgeFlowDesignerApp(state);
export const isUsingSSO = createSelector(
  [isSamlEnabled, isUsingCAS],
  (samlEnabled, usingCAS) => samlEnabled || usingCAS,
);

export const isWarningDialogOpen = state => state?.session?.showWarning;

export const getSessionUserId = state => getClientSession(state)?.userId;
export const getSessionTimeout = state => state.session.timeout;
